var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-look",
    viewBox: "0 0 1638 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M819.2 0c425.984 0 781.2096 428.9536 796.16 447.1808a102.4 102.4 0 0 1 0 129.6384l-4.096 4.9152C1567.8464 633.0368 1225.8304 1024 819.2 1024 393.216 1024 38.0928 594.944 23.1424 576.8192a102.4 102.4 0 0 1 0-129.6384C38.0928 428.9536 393.216 0 819.2 0z m0 204.8C592.2816 204.8 361.3696 389.5296 241.0496 511.488 346.112 618.0864 576.512 819.2 819.2 819.2c227.0208 0 457.9328-184.7296 578.2528-306.688C1292.288 405.9136 1061.888 204.8 819.2 204.8z m0 102.4A204.8 204.8 0 1 1 819.2 716.8 204.8 204.8 0 0 1 819.2 307.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLook);
export default __webpack_public_path__ + "static/media/look.c8524e33ff01a1e51d50a20131717c9d.svg";
export { ForwardRef as ReactComponent };